import { getHeaders } from '@ori/presentation-graphql';
import axios from 'axios';
import { query } from './query';
import { APPLICATION_NAME } from '../../constants';
import { mapProductsFromGql } from '../mappers';
export var getProductInfoDialogProducts = async function getProductInfoDialogProducts(props) {
  var currentLanguage = props.currentLanguage,
    globalApiUrl = props.globalApiUrl,
    graphQlUrl = props.graphQlUrl,
    productCodes = props.productCodes,
    tenant = props.tenant,
    token = props.token,
    atpClusterId = props.atpClusterId,
    customerId = props.customerId;
  var url = new URL('/graphql', graphQlUrl);
  var _await$axios$post = await axios.post(url.toString(), {
      query: query,
      variables: {
        productCodes: productCodes
      }
    }, {
      headers: await getHeaders({
        currentLanguage: currentLanguage,
        globalApiUrl: globalApiUrl,
        tenant: tenant,
        token: token,
        applicationName: APPLICATION_NAME,
        atpClusterId: atpClusterId,
        customerId: customerId
      })
    }),
    products = _await$axios$post.data.data.products;
  return products ? mapProductsFromGql(products) : [];
};